const EMPTY_ARRAY_LENGTH = 0;
export function isEmptyArray(array: unknown): boolean {
  return Array.isArray(array) && array.length === EMPTY_ARRAY_LENGTH;
}
